<div *ngIf="isFilterToggle; else routeToggleLayout" class="filter-toggle-button-group"
  [style.grid-template-columns]="filterToggleColumns">
  <app-button *ngFor="let option of filterOptions" [data]="filterOptionData(option)"></app-button>
</div>

<ng-template #routeToggleLayout>
<div *ngIf="isSpecialSplitLayout; else defaultToggleLayout" class="toggle-button-group is-special-split"
  style="margin-top: 2px;">
  <div class="toggle-top-subgroup" [style.grid-template-columns]="'repeat(' + topOptions.length + ', minmax(0, 1fr))'">
    <button *ngFor="let option of topOptions" class="toggle-btn" [class.active]="isActive(option)"
      (click)="onToggle(option)">
      {{ formatLabel(option.label) }}
    </button>
  </div>

  <div class="toggle-subgroup" [style.grid-template-columns]="'repeat(' + bottomOptions.length + ', minmax(0, 1fr))'">
    <button *ngFor="let option of bottomOptions" class="toggle-btn" [class.active]="isActive(option)"
      (click)="onToggle(option)">
      {{ formatLabel(option.label) }}
    </button>
  </div>
</div>

<ng-template #defaultToggleLayout>
  <div class="toggle-button-group" style="margin-top: 2px;"
    [style.grid-template-columns]="'repeat(' + displayOptions.length + ', minmax(0, 1fr))'">
    <button *ngFor="let option of displayOptions" class="toggle-btn" [class.active]="isActive(option)"
      (click)="onToggle(option)">
      {{ formatLabel(option.label) }}
    </button>
  </div>
</ng-template>
</ng-template>
